import { isNull } from "lodash";

import { parseISO } from "date-fns";

import { useNotify } from "data/messages/hooks";

import { useMutationWithToaster } from "hooks";

import toGlobalId from "../../../api/helper";
import { createResolverFactory } from "../../WorkflowContainer/components/FormFieldBuilder/hooks";

function mutationFactory() {
  const query = `
  mutation submitFormInstance($id: ID!, $values: [FieldValueInput]!, $completeTask: Boolean) {
    submitFormInstance(id: $id, values: $values, completeTask: $completeTask) {
      formInstance {
        id
        isFilled
        fieldValues {
          edges {
            node {
              id
              name
              value {
                ... on StringValue {
                  stringValue
                }
                ... on BooleanValue {
                  booleanValue
                }
                ... on DateTimeValue {
                  datetimeValue
                }
                ... on ArrayStringValue {
                  arrayStringValue
                }
              }
              dataType
              options
              type {
                showOptions
                text
                id
              }
            }
          }
        }
      }
    }
  }`;

  const resolver = ({ data }) => {
    const formInstance = data?.submitFormInstance?.formInstance;
    return {
      data: {
        ...formInstance,
        fieldValues: (formInstance?.fieldValues?.edges || []).map(
          ({ node: { dataType, value, ...vNode } }) => {
            const v = isNull(Object.values(value)[0])
              ? undefined
              : Object.values(value)[0];

            return {
              ...vNode,
              dataType: dataType,
              value: v && dataType === "DATETIME" ? parseISO(v) : v,
            };
          }
        ),
      },
    };
  };
  return { query: query, resolver: createResolverFactory(resolver) };
}

export function useFormAction(formInstanceId, onDone) {
  const notifyCardTasks = useNotify("CLIENT_CARD_TASKS");
  const notifyClientCardNextWorkflows = useNotify("CLIENT_CARD_NEXT_WORKFLOWS");
  const notifyUpcomingReminders = useNotify("CLIENT_CARD_UPCOMING_REMINDERS");

  const formatValueToSubmit = (data) => {
    return Object.keys(data).map((key) => {
      return { id: key, value: data[key] };
    });
  };

  const [submitForm, { loading: isSubmitting }] = useMutationWithToaster(
    mutationFactory,
    {
      onDone: (data) => {
        onDone(data);
        notifyCardTasks([true]);
        notifyClientCardNextWorkflows([true]);
        notifyUpcomingReminders([true]);
      },
    }
  );

  return {
    isSubmitting: isSubmitting,
    submit: (data, completeTask) => {
      return submitForm(
        {
          id: toGlobalId("FormInstance", formInstanceId),
          values: formatValueToSubmit(data),
          completeTask: completeTask,
        },
        {
          successMsg: "Form submitted successfully.",
          defaultErrorMsg: "Failed to submit form",
        }
      );
    },
  };
}

export default useFormAction;
